import { createApi } from "@reduxjs/toolkit/query/react";

import { axiosBaseQuery } from "./axiosBaseQuery";

/**
 * Root RTK Query API. Feature domains attach their endpoints via
 * `baseApi.injectEndpoints` (see src/services/accounts/accountsApi.ts) so each
 * domain owns its own endpoints, mirroring the per-domain src/services/<domain>
 * layout. New tag types are added here as domains are migrated.
 */
export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    "Account",
    "AdminAuditLog",
    "AdminCorporateAction",
    "AdminInstrument",
    "AdminInstrumentTodo",
    "AdminJob",
    "AdminOverview",
    "AccountBalanceHistory",
    "AccountStats",
    "AccountSummary",
    "AccountYears",
    "Cashback",
    "Category",
    "Finances",
    "HealthTargets",
    "Holding",
    "HoldingTrade",
    "Instrument",
    "Investment",
    "InvestmentGoal",
    "InvestmentHistory",
    "InvestmentMarketUpdate",
    "InvestmentTransfer",
    "InvestmentTypes",
    "InvestmentYears",
    "Liability",
    "LiabilityBalanceHistory",
    "LiabilityTypes",
    "LiabilityYears",
    "PriceOverride",
    "RecurringTransaction",
    "Report",
    "Saving",
    "SavingsGoal",
    "SavingHistory",
    "SavingYears",
    "TickerRequest",
    "Transaction",
    "User",
  ],
  endpoints: () => ({}),
});
